import React from 'react';
import ReactGA from 'react-ga';
import StackTrace from 'stacktrace-js';

// A very basic Error Catch using React ErrorBoundary and GA
// We send GA the error message, component and the page URL

// In the future we will use a proper error tracking tool
// Each browser prints a different stack trace so results
// not always accurate

class ErrorBoundary extends React.Component {
  trackError(error) {
    // We use stacktrace-js for browser support
    // We avoid any string manipulation here because errors are
    // not standardised across browsers and we dont want to
    // risk causing an error in this function

    // Do not make network requests in test enviromments
    // stacktrace-js uses network requests to locate precise
    // location of error (using stacktrace-gps)
    const offline = process.env.NODE_ENV !== 'production';

    return StackTrace.fromError(error, { offline }).then(stackFrames => {
      const firstError = stackFrames[0];
      const appVersion = this.props.appVersion;

      // The exception is printed as:
      // Component.FunctionName:LineNumber (App Version)
      // But may vary in different browsers according to
      // stacktrace.js
      const exception = `${firstError.functionName}:${
        firstError.lineNumber
      } (${appVersion})`;

      const gaEvent = {
        // Catagory is always 'LUX Events'
        category: 'LUX Errors',
        // Action is the exception
        action: exception,
        // Label is the page url
        label: window.location.origin + window.location.pathname,
        nonInteraction: false
      };

      // Only track production errors
      if (process.env.NODE_ENV === 'production') {
        ReactGA.event(gaEvent, ['lux']);
      }

      // We return the variables we would've send to GA if we were in production
      return gaEvent;
    });
  }

  componentDidCatch(error) {
    this.trackError(error);
  }

  // We fail silently and let React unmount the children
  render() {
    return this.props.children;
  }
}

export default ErrorBoundary;
